import Dexie from 'dexie'

const db = new Dexie('phrases-translation')
db.version(1).stores({
    phrases_translation: `&updated, phrases`
})

export default db
